/**
 * Abrir un PDF que solo se puede pedir con sesión (cabecera Authorization): se descarga como Blob y se muestra
 * desde una URL local. La pestaña se abre en el mismo clic (si no, el navegador bloquea la ventana emergente) y
 * se rellena cuando llega el PDF.
 */

export function openBlankTab(): Window | null {
  return typeof window === "undefined" ? null : window.open("", "_blank");
}

/** Muestra el PDF en la pestaña ya abierta; si no hay pestaña (bloqueada), lo descarga con el nombre dado. */
export function showPdfBlob(blob: Blob, tab: Window | null, filename: string): void {
  const typed = blob.type === "application/pdf" ? blob : new Blob([blob], { type: "application/pdf" });
  const url = URL.createObjectURL(typed);
  if (tab && !tab.closed) {
    tab.location.href = url;
  } else {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  // La pestaña necesita la URL viva un rato mientras carga el visor de PDF.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/** Nombre de descarga de una factura fiscal. */
export function fiscalPdfFilename(reference: string | null | undefined, rectificative: boolean): string {
  const base = reference && reference.length > 0 ? reference : "factura";
  return `${rectificative ? "rectificativa" : "factura"}-${base}.pdf`;
}
